import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { useMyDay } from '../lib/hooks.js';
import { Badge, Card, EmptyState, Skeleton } from '../ui/index.js';
import { label, statusTone } from '../lib/format.js';

function hm(iso: string): string { return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); }

/** Technician "Today" — the mobile-first field home. Big tap targets, chronological jobs. */
export function MyDay() {
  const { session } = useAuth();
  const today = new Date().toISOString().slice(0, 10);
  const { data, isLoading } = useMyDay(session!.userId, today);
  const navigate = useNavigate();
  const jobs = (data?.items ?? []).filter((a) => a.status !== 'canceled').sort((a, b) => a.start.localeCompare(b.start));

  return (
    <div className="myday">
      <div className="page-head"><div><div className="page-title">Today</div><div className="page-sub">{new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</div></div></div>
      {isLoading ? <Card className="card-pad"><Skeleton h={80} /></Card>
        : jobs.length === 0 ? <Card className="card-pad"><EmptyState icon="✅" title="No jobs scheduled today" >Enjoy the quiet — or check back after dispatch assigns work.</EmptyState></Card>
        : jobs.map((a) => (
          <div key={a.aid} className={`jobcard ${a.status === 'completed' ? 'done' : ''}`} onClick={() => navigate(`/my/${a.customerId}/${a.jobId}`)} role="button">
            <div className="row between">
              <span className="jobcard-time">{hm(a.start)}</span>
              <Badge tone={statusTone(a.status)}>{label(a.status)}</Badge>
            </div>
            <div style={{ fontWeight: 600, marginTop: 4 }}>{a.title}</div>
            <div className="subtle" style={{ fontSize: 'var(--text-xs)', marginTop: 2 }}>Tap to open job →</div>
          </div>
        ))}
    </div>
  );
}
